<template>
  <div class="home-gallery">
    <ImageGalleryTitle :center="true">
      <template v-slot:subtitle>
        People like you, making us look good. <a class="see-all-ugc accent" :href="ugcDisplayLink()">View the gallery</a>.
      </template>
    </ImageGalleryTitle>
    <ImageGallery :images="images" :page-size="pageSize" :has-more="next" :loading="loading" :overflow-hidden="false" @loadMore="load"></ImageGallery>
  </div>
</template>

<script>
import ImageGallery from './ImageGallery.vue';
import ImageGalleryTitle from './ImageGalleryTitle.vue';
import { loadHomeImages } from './UGCService.js';

export default {
  components: {
    ImageGallery,
    ImageGalleryTitle,
  },

  data() {
    return {
      loading: true,
      images: [],
      page: 1,
      pageSize: 25,
      next: true,
    };
  },

  mounted() {
    this.load();
  },

  methods: {
    async load() {
      if (!this.next) {
        return;
      }
      this.loading = true;
      const result = await loadHomeImages(this.page, this.pageSize);
      this.page += 1;
      this.next = result && result.success && result.next;
      if (result && result.success && result.data) {
        this.images = [...this.images, ...result.data];
      }
      this.loading = false;
    },

    ugcDisplayLink() {
      return this.$router.resolve({ name: 'ugcDisplay' }).href;
    },
  },
};
</script>
<style lang="postcss">
@import '@/pixel/style/variables';
@import '@/pixel/style/mixins';

.home-gallery {
  @mixin escapeResponsiveContainerPadding;
}
</style>
